// extracted by mini-css-extract-plugin
module.exports = {"timerSection":"Timer_timerSection__bLkux","blocks":"Timer_blocks__2UNmR","block":"Timer_block__P4V_w","number":"Timer_number__C1_qb","unit":"Timer_unit__CLmIk"};